import React from 'react';
import MapboxCluster from '../components/MapboxCluster';

export default function CompsManager() {
  return (
    <div style={{ padding: 20 }}>
      <h2>Comps Manager</h2>
      <MapboxCluster comps={[{ id: 1 }, { id: 2 }]} />
    </div>
  );
}
